module.exports = __webpack_public_path__ + "static/media/primary_icon.aac3cc51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/primary_icon.svg
// module id = 251
// module chunks = 0